import React, { useState, useEffect } from "react";

import "./styles.scss";

const GradeTablesMajorMinor = ({ studentsData }) => {
  const [notas, setNotas] = useState(null);

  useEffect(() => {
    let arrayDeNotas = []; // média, maior, menor

    let soma = 0;
    let menor = 0;
    let maior = 0;

    for (let i = 0; i < studentsData.length; i++) {
      soma += studentsData[i].nota;

      if (studentsData[i].nota > maior) {
        maior = studentsData[i].nota;
      }

      if (i === 0) {
        menor = studentsData[i].nota;
      } else if (studentsData[i].nota < menor) {
        menor = studentsData[i].nota;
      }

      if (i === studentsData.length - 1) {
        arrayDeNotas.push(soma / studentsData.length);
        arrayDeNotas.push(maior);
        arrayDeNotas.push(menor);
      }

      setNotas(arrayDeNotas);
    }
  }, [studentsData]);

  return (
    <>
      {/* <div className="row-tabelaDesempenho">
        <table id="tabelaGradeTables">
          <thead>
            <th>Total de Alunos</th>
            <th>Menor Nota</th>
            <th>Maior Nota</th>
            <th>Média</th>
          </thead>
          <tbody>
            <tr>
              <td>{studentsData.length}</td>
              <td>{notas && notas[2]}</td>
              <td>{notas && notas[1]}</td>
              <td>{notas && notas[0]}</td>
            </tr>
          </tbody>
        </table>
      </div> */}

      <div className="" style={{ marginBottom: "40px" }}>
        <table className="table table-hover table-outline mb-0 d-none d-sm-table gradeTablesMajorMinor">
          <thead className="thead-light">
            <tr>
              <th>Total de Estudantes</th>
              <th>Menor Nota</th>
              <th>Maior Nota</th>
              <th>Média</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{studentsData.length}</td>
              <td>{notas && notas[2]}</td>
              <td>{notas && notas[1]}</td>
              <td>{notas && notas[0].toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* <div className="layoutTabela">
        <CRow>
          <CCol>
            <CCard>
              <CCardBody>
                {notas && (
                  <CDataTable
                    items={[
                      {
                        Total_de_Alunos: `${studentsData.length}`,
                        Menor_Nota: `${notas && notas[2]}`,
                        Maior_Nota: `${notas && notas[1]}`,
                        Media: `${notas && notas[0].toFixed(2)}`,
                      },
                    ]}
                    hover
                    striped
                    bordered
                    size="sm"
                    itemsPerPage={10}
                    pagination
                  />
                )}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div> */}
    </>
  );
};

export default GradeTablesMajorMinor;
